import React from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';

import LogIn from './LogIn';
import SignUp from './SignUp';
import CompleteRegistration from './CompleteRegistration';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import ChangePassword from './ChangePassword';

/**
 * TODO: Routes
 * - Signup
 * - Registration Complete {token}
 * - Registration Resend {emailAddress}
 * - Login
 * - Change Password
 * - Forgot Password Initiate {emailAddress}
 * - Forgot Password Complete {token} [SILENT]
 */

const Routes = ({match}) => (
  <Switch>
    <Route
      path={`${match.path}/register/complete/:token`}
      component={CompleteRegistration}
    />
    <Route
      path={`${match.path}/forgot-password/reset/:token`}
      component={ResetPassword}
    />
    <Route path={`${match.path}/forgot-password`} component={ForgotPassword} />
    <Route path={`${match.path}/login`} component={LogIn} />
    <Route path={`${match.path}/signup`} component={SignUp} />
    <Route path={`${match.path}/change-password`} component={ChangePassword} />
    <Redirect to="/login" />
  </Switch>
);
export default Routes;
